import React from 'react'
import { AppRoutes } from './config/Routes'
import { Provider } from 'react-redux'
import { store } from './store'
import { ApolloProvider } from '@apollo/client'
import { client } from './core/query'
import { LogRocketScripts } from './core/LogRocketScripts'

function App() {
  return (
    <>
      <LogRocketScripts />
      <ApolloProvider client={ client }>
        <Provider store={ store }>
          <AppRoutes/>
        </Provider>
      </ApolloProvider>
    </>
  )
}

export default App
